// Share the instance module in the next-shared layer
import { afterTaskAsyncStorageInstance as afterTaskAsyncStorage } from './after-task-async-storage-instance' with {
    'turbopack-transition': 'next-shared'
};
export { afterTaskAsyncStorage };

//# sourceMappingURL=after-task-async-storage.external.js.map